import { storage } from '../../../storage';
import { is } from '../../../xenv';
import { utils } from '../../../utils';
import { HyDriverJump } from './goTo';
class Native {
    constructor() {
        // 与bridge建立连接
        this.connectIOS = () => {
            let bridge = window.WebViewJavascriptBridge || window.WebJsBridge;
            if (!window.WVJBCallbacks)
                window.WVJBCallbacks = [];
            if (bridge) {
                return true;
            }
            else {
                // 初始化
                let WVJBIframe = document.createElement('iframe');
                WVJBIframe.style.display = 'none';
                WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
                document.documentElement.appendChild(WVJBIframe);
                setTimeout(() => {
                    document.documentElement.removeChild(WVJBIframe);
                }, 0);
                return window.WebViewJavascriptBridge || window.WebJsBridge;
            }
        };
        this.connectIOS();
    }
    callHandler(name, params, callback) {
        let data = params || null;
        if (is('ios')) {
            this.callHandlerIOS(name, data, callback);
        }
        else if (is('android')) {
            this.callHandlerAndroid(name, data, callback);
        }
    }
    // ios端bridge方法调用
    callHandlerIOS(name, data, callback) {
        let bridge = this.getBridge();
        let cbFunc = (bridge) => {
            bridge.callHandler(name, data, callback);
        };
        if (bridge) {
            cbFunc(bridge);
            // bridge.callHandler(name, data, callback)
        }
        else {
            window.WVJBCallbacks.push(cbFunc);
        }
    }
    // android端bridge方法调用
    callHandlerAndroid(name, data, callback) {
        let bridge = this.getBridge();
        let params = data;
        if (bridge) {
            if (utils.isObj(params)) {
                params = JSON.stringify(params);
            }
            let result = bridge[name](params);
            callback && callback(result);
        }
    }
    // 获取bridge
    getBridge() {
        let bridge;
        // this.connectIOS()
        if (is('ios')) {
            bridge = window.WebViewJavascriptBridge;
        }
        else if (is('android')) {
            bridge = window.WebJsBridge;
        }
        return bridge;
    }
}
let hydriverBridge;
if (is('hydriver')) {
    hydriverBridge = new Native();
}
function commonJump(loadParams, xenv, commonParams = {}) {
    new HyDriverJump(loadParams, xenv, commonParams).doJump();
}
/* 货运司机端登录 */
const hydriverLogin = (option, callback) => {
    return new Promise((resolve, reject) => {
        hydriverBridge.callHandler('getUserInfo', null, res => {
            if (typeof res === 'string') {
                res = JSON.parse(res);
            }
            const { useQuick } = option || {};
            if (res && res.ticket) {
                const userInfo = {
                    token: res.ticket || res.token,
                    phone: res.phone,
                    uid: res.userId || ''
                };
                storage.userInfo = { ...userInfo };
                let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: res.token || res.ticket });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                /* 执行传入cb */
                useQuick && callback && callback({ ...userInfo });
                resolve({ ...userInfo });
            }
            else {
                storage.userInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject({});
            }
        });
    });
};
/* 货运司机端获取定位信息 */
const hydriverLocate = () => {
    return new Promise((resolve, reject) => {
        hydriverBridge.callHandler('getLocationInfo', null, res => {
            if (typeof res === 'string') {
                res = JSON.parse(res);
            }
            if (res && (res.lng || res.lat)) {
                storage.locationInfo = {
                    lng: Number(res.lng || 0),
                    lat: Number(res.lat || 0),
                    cityId: Number(res.cityId || 0),
                    area: String(res.area || '')
                };
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: res.lat, longitude: res.lng, cityId: String(res.cityId) });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                resolve({
                    lng: Number(res.lng || 0),
                    lat: Number(res.lat || 0),
                    cityId: Number(res.cityId || 0),
                    area: String(res.area || '')
                });
            }
            else {
                storage.locationInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined, cityId: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject({});
            }
        });
    });
};
/* 货运司机端设置登录信息 */
const hydriverSetLoginConfig = () => { };
/* 货运司机端获取系统信息 */
const hydriverGetSystemInfo = () => {
    return new Promise((resolve) => {
        hydriverBridge.callHandler('getNativeParams', null, res => {
            if (typeof res === 'string') {
                res = JSON.parse(res);
            }
            resolve(res);
        });
    });
};
/* 货运司机端保存图片，只支持base64格式 */
const hydriverSaveImg = async (url) => {
    const convertImgToBase64 = (url, outputFormat) => {
        return new Promise((resolve) => {
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            let img = new Image;
            img.crossOrigin = 'Anonymous';
            img.onload = () => {
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL(outputFormat || 'image/png');
                resolve(dataURL);
                canvas = null;
            };
            img.onerror = () => {
                resolve('');
            };
            img.src = url;
        });
    };
    const imgBase64 = await convertImgToBase64(url);
    return new Promise((resolve, reject) => {
        if (!imgBase64)
            reject();
        hydriverBridge.callHandler('saveImage', imgBase64, res => {
            res ? resolve(res) : reject(res);
        });
    });
};
export { hydriverBridge, hydriverLogin, hydriverLogin as hydriverIsLogin, hydriverLocate, hydriverGetSystemInfo, commonJump as hydriverCommonJump, hydriverSaveImg, hydriverSetLoginConfig };
